<template>
  <div>
    <metainfo>
      <template v-slot:title="{ content }">
        {{ content ? ` ${title} | ${content} ` : `${title}` }}
      </template>
    </metainfo>
    <router-view />
    <CookieConsent />
    <UiToastList />
  </div>
</template>

<script>
import UiToastList from '@src/components/misc/UiToastList.vue'
import appConfig from '@src/app.config'
import { mapState } from 'vuex'
import CookieConsent from '@src/components/CookieConsent.vue'

export default {
  name: 'App',

  components: {
    UiToastList,
    CookieConsent,
  },

  data() {
    return {
      title: appConfig.title,
    }
  },
  computed: {
    ...mapState(['currentSelectedLanguage']),
  },
  mounted() {
    (String.prototype.toArabicDigits = function () {
      return this.replace(/\d/g, (d) => '٠١٢٣٤٥٦٧٨٩'[d])
    }),
      (String.prototype.toDigits = function () {
        return this.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
      })
      document.documentElement.setAttribute('lang-is',this.currentSelectedLanguage.short||'en')

  },
}
</script>

<style>
html,
body {
  overflow-x: hidden;
}
</style>